// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".purchase-button-container[data-v-ff408458]{position:relative;display:inline-block}\n", ""]);
// Exports
module.exports = exports;
